import { useContext, useEffect, useState } from "react";
import AppContext from "../../Context/AppContext";
import { depositCheck } from "../../utils/depositCheck";
import Alert from "../Alert";

function DepositChecker({
  formData,
  calculatedPropertyPurchasePrice,
  propertyRegionDetails,
}) {
  const { showResults } = useContext(AppContext);

  const [alerts, setAlerts] = useState({});

  useEffect(() => {
    try {
      const depositCheckResult = depositCheck(
        calculatedPropertyPurchasePrice,
        formData.deposit,
        formData.buyToLet,
        formData.schemes === "helpToBuy" ? true : false,
        //formData.helpToBuy,
        //formData.firstHomes,
        formData.schemes === "firstHomes" ? true : false,
        formData.firstHomesGreaterLondon,
        propertyRegionDetails,
      );

      setAlerts((prev) => ({ ...prev, deposit: depositCheckResult }));
    } catch {
      return false;
    }
  }, [formData, calculatedPropertyPurchasePrice, propertyRegionDetails]);

  return (
    <>
      {showResults &&
      calculatedPropertyPurchasePrice > 0 &&
      // Previously: formData.deposit &&
      // Updated to support 100% mortgages where deposit is intentionally 0.
      // typeof check ensures empty/null/undefined are rejected, while 0 (a number) is valid.
      // NaN is typeof "number" so we must also guard against it (e.g. when the field is cleared).
      typeof formData.deposit === "number" &&
      !isNaN(formData.deposit) &&
      formData.schemes !== "sharedOwnership" ? (
        <div className="frost relative z-10 mb-8 w-full rounded-lg border border-gray-200 bg-white p-4 pb-4 shadow-xl shadow-purple-500/25">
          <h2 className="mb-4 text-3xl leading-none text-black dark:text-white ">
            Deposit
          </h2>

          <div className="mb-0">
            {alerts.deposit && (
              <Alert
                type={alerts.deposit[0]}
                text={alerts.deposit[1]}
                // background={alerts.deposit[2]}
              />
            )}
          </div>

          {/* <div>
            <p className="text-xs text-black dark:text-white">
              The above results are based on the{" "}
              {formData.buyToLet ? "deposit" : "income"} figure you've provided.
              Please be aware that{" "}
              {formData.buyToLet
                ? "rental income and financial commitments will need to be"
                : "credit commitments and credit ratings have not been"}{" "}
              taken into consideration.
            </p>
          </div> */}
        </div>
      ) : null}
    </>
  );
}

export default DepositChecker;
